import { AsyncPipe, NgIf, CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import {
  ButtonComponent,
  ButtonTextComponent,
} from '@domgen/dgx-fe-components/button';
import { CategoryAccordionBlockComponent } from '@domgen/dgx-fe-components/category';
import {
  MultipleButtonContentCardComponent,
  PopularLinkListBlockComponent,
} from '@domgen/dgx-fe-components/content';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { NavigationLinkDirective } from '@domgen/dgx-fe-components/navigation';
import {
  TranslatePipe,
  provideTranslationDictionaryMapping,
} from '@domgen/dgx-fe-i18n';
import { SeoPage } from '@domgen/dgx-fe-seo';
import { EditableArea } from '@magnolia/angular-editor';
import { translation } from '../../i18n/translation.constant';
import { YourApplianceComponentService } from '../../services/your-appliance-component/your-appliance-component.service';
import { VideoListBlockComponent } from '../../../../../feature-components/src';
import { SmartFixHubAnalyticsService } from 'libs/self-fix/data-access/src/lib/services/sf-hub-analytics/sf-hub-analytics-service';

@Component({
  standalone: true,
  imports: [
    AsyncPipe,
    CategoryAccordionBlockComponent,
    EditableArea,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    MultipleButtonContentCardComponent,
    NgIf,
    PopularLinkListBlockComponent,
    TranslatePipe,
    VideoListBlockComponent,
    CommonModule,
  ],
  providers: [
    YourApplianceComponentService,
    provideTranslationDictionaryMapping(translation),
  ],
  templateUrl: './your-appliance.component.html',
  styleUrls: ['./your-appliance.component.scss'],
})
@SeoPage()
export class YourApplianceComponent implements OnInit {
  constructor(
    readonly cs: YourApplianceComponentService,
    private readonly smartFixAnalytics: SmartFixHubAnalyticsService
  ) {}

  ngOnInit(): void {
    this.smartFixAnalytics.trackEvent({
      pagename: 'claims-sf-hub-your-appliance',
      event: 'spa-pageview',
    });
  }

  popularArticleClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    // event.preventDefault();
    const articleClickedtitle = target.closest('a')?.innerText || '';

    this.smartFixAnalytics.trackEvent({
      eventCategory: 'sf-hub',
      eventAction: 'article selected',
      eventLabel: articleClickedtitle,
      pagename: 'claims-sf-hub-your-appliance',
      event: 'genericGAEvent',
    });
  }
}
